import * as React from 'react';

import {Popover} from 'shells/popover/popover';
import {PopoverForm} from 'shells/popover-form/popover-form';
import {Body} from 'shells/typography/body';

import type {
    GetProducts_products_edges_node as Product,
    ProductDeleteInput,
} from 'nutshell-graphql-types';

import {notifyUser} from './helpers';

type Props = {
    onClose: () => void;
    anchor: HTMLElement | null | undefined;
    product: Product;
    onSubmit: (input: ProductDeleteInput) => Promise<any>;
};

export function ProductConfirmArchivePopover(props: Props) {
    const handleSubmit = () => {
        props.onSubmit({productId: props.product.id}).then(() => notifyUser(props.product, true));

        props.onClose();
    };

    return (
        <Popover anchor={props.anchor} location='bottom' onBlur={props.onClose}>
            <PopoverForm
                title='Archive product'
                onClose={props.onClose}
                onSubmit={handleSubmit}
                saveButtonText='Yes, archive'
                saveButtonVariant='danger'
                cancelButtonText='No, don’t archive'
                width={375}
            >
                <div className='pt-16 pb-32'>
                    <Body>
                        Are you sure you want to archive this product? It won’t be available for
                        leads, quotes, and invoices moving forward.
                    </Body>
                </div>
            </PopoverForm>
        </Popover>
    );
}
